import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from '../../../QestIds';
import getDerivedFromMeasurementsConfig from '../../derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

const massConfig = { format: { nearest: 0.1 }, uom: 'g' };

const getConfig = (prefix: string) =>
  mergeConfig(
    getLabelConfig(prefix),
    {
      [`${prefix}.Preparation.MixMaximumParticleSize`]: { format: { nearest: 0.01 }, uom: 'mm' },

      [`${prefix}.InitialDrying.BalanceInitialDrying`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.InitialDrying.DryMassBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.InitialDrying.TareMass`]: massConfig,
      [`${prefix}.InitialDrying.TestPortionWetMass`]: massConfig,
      [`${prefix}.InitialDrying.OvenTemperature`]: { uom: '°C', format: { nearest: 1 } },

      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.01 },
      },
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]:
        massConfig,
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerMass`]: massConfig,
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilAndContainerMass`]: massConfig,
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilMass`]: massConfig,
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.DryingTemperature`]: {
        uom: '°C',
        format: { nearest: 1 },
      },
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.Balance`]: {
        defaultReadability: 0.1,
        defaultUom: 'g',
      },
      [`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 0.1,
        defaultUom: 'g',
      },

      [`${prefix}.InitialDrying.TestPortionDryMass`]: massConfig,
      [`${prefix}.InitialDrying.MoistureVolatileContent`]: { format: { nearest: 0.01 }, uom: '%' },

      [`${prefix}.Measurements.BalanceBinderExtraction`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Measurements.BalanceBinderSeparation`]: { defaultReadability: 0.01, defaultUom: 'g' },
      [`${prefix}.Measurements.Trials.BinderContentPercentage`]: { format: { nearest: 0.01 }, uom: '%' },

      [`${prefix}.Results.BinderContentFinal`]: { format: { nearest: 0.01 }, uom: '%' },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix)
  );

export { getConfig };
export default {
  [qestIds.binderContent.AS_2891_3_2.rev2013]: getConfig,
};
